import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Col, Row, Button, Container, Card, Modal } from "react-bootstrap";
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import { Decrypt } from '../../utils/Helper';
import { Margin, usePDF } from "react-to-pdf";
import { GetNotification, GetNotificationCertificate, GetAdminNotification } from "../../utils/axios/NotificationAPI";
import { GrokLoading } from "../page-layout/loading/Loading";
import { getRoles } from '../../utils/swtAlert';
import "../winnerAnnouncement/Certificate.css"

function Notification(props) {

  const [userInfo, setuserInfo] = useState(JSON.parse(Decrypt(sessionStorage.getItem('userInfo'))));
  const [ userDetails ] = useState(Decrypt(sessionStorage.getItem('userDetails')));
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [adminData, setAdminData] = useState([]);
  const [certificateData, setCertificateData] = useState([]);
  const [role, setRole] = useState('');

  const [notificationShow, setNotificationShow] = useState(false);
  const [reloadHeader, setReloadHeader] = useState(false);
  const handleCloseNotification = () => {
    setNotificationShow(false);
    setReloadHeader(prev => !prev);
  };
  const handleShowNotification = async (StudentChallengeId) => {
    setNotificationShow(true);
    await getNotificationCertificate(StudentChallengeId);
    getNotification();
  }

  const BackBtn = () => {
    navigate('/home');
  }

  const filterRef = useRef();
  const { toPDF, targetRef } = usePDF({
    // filename: (`${name}-${challengeName}`),
    filename: "challenge winner",
    page: { margin: Margin.MEDIUM }
  });

  // const handleMarkRead = () => {
  //   let item1 = document.querySelectorAll(".notification_content_unread");
  //   item1[1].classList.remove('notification_content_unread');
  //   item1[1].classList.add('notification_content_read');

  //   let itemicon = document.querySelectorAll(".notification_dot");
  //   itemicon[1].style.display = 'none';
  // }

  const getNotification = async () => {
    let notificationPayload = {
      StudentId: userInfo.StudentId
    }

    setLoading(true);
    let notificationResponse = await GetNotification(notificationPayload);
    setData(notificationResponse.data);
    setLoading(false);
  }

  const getAdminNotification = async () => {
    let adminnotificationResponse = await GetAdminNotification();
    setAdminData(adminnotificationResponse.data);
    setLoading(false);
  }

  const handleRegisterationPage = (Id) => {
    navigate('/newenrollusersdetails', { state: { studentid: null, tempUserId: Id } });
  }
  
  const getNotificationCertificate = async (challengeId) => {
    let notificationCertificatePayload = {
      StudentChallengeId: challengeId
    }
    setLoading(true);
    let notificationCertificateResponse = await GetNotificationCertificate(notificationCertificatePayload);
    setCertificateData(notificationCertificateResponse.studentChallenge);
    setLoading(false);
  }

  const getRoleBasedNotificationAPI  = (role) => {
    if(role=="Grok Admin"){
      getAdminNotification();
    }
    else{
      getNotification();
    }
  }

  useEffect(() => {
    const role = getRoles(userInfo);
    setRole(role);
    getRoleBasedNotificationAPI(role);
  }, [])

  return (
    <div className='page'>
      <NavMenu />
      <Header notificationCount={adminData?.MarkAsUnReadCount} reloadHeader={reloadHeader} /> 
      <div className='page-wrapper'>
        <Container className="mt-3">
          <div className="d-flex flex-column align-items-center justify-content-center">
            <Card className="notification_card">
              <Card.Body>
                {loading ? <GrokLoading /> : ""}
                <div className="d-flex justify-content-between notification_box">
                  <div className="d-flex">
                    {(role=='Student') && <Card.Title className="notification_head">Notifications</Card.Title>}
                    {(role=='Grok Admin') && <Card.Title className="notification_head">New Registration Notification</Card.Title>}
                    {(role=='Student') && <p className="notification_count">{data.MarkAsUnReadCount}</p>}
                    {(role=='Grok Admin') && <p className="notification_count">{adminData.MarkAsUnReadCount}</p>}
                  </div>
                  <span className="notification_icon" onClick={() => BackBtn()}>
                    <svg stroke="currentColor" fill="none" strokeWidth="0" viewBox="0 0 15 15" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z" fill="currentColor"></path></svg>
                  </span>
                </div>
                {(role=='Grok Admin') && <div style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                  {adminData?.data?.map(item =>
                    <Card.Text className={item.MarkAsRead ? "notification_content_read" : "notification_content_unread"}>
                      <div className="dropdown-item-text d-flex justify-content-between" onClick={() => handleRegisterationPage(item.Id)}>
                        <div className="d-flex align-items-center">
                          <div className="avatarimg_notify">
                            <img src={require("../../images/user_pfl-1.png")} className="img-fluid" width={80 } height={80 } alt="admin_notify_icon" />
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <h5 className="persontexthead">Name: {item.DisplayName}</h5>
                            <p className="card-text text-body persontextpara">Industry Use Case Name : <b>{item.ChallengeName}</b><br /> <span>Email: <b>{item.Email}</b></span></p>
                            <h5 className="persontexthead">Click the "View Details" button for more information.</h5>
                          </div>
                        </div>
                        <div className={item.MarkAsRead ? "" : "notification_dot"}>.</div>
                      </div>
                    </Card.Text>
                  )}
                </div>}
                {(role=='Student') && <div style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                  {data?.data?.map(item =>
                    <Card.Text className={item.MarkAsRead ? "notification_content_read" : "notification_content_unread"}>
                      <div className="dropdown-item-text d-flex justify-content-between" onClick={() => handleShowNotification(item.StudentChallengeId)}>
                        <div className="d-flex align-items-center">
                          <div className="avatarimg_notify">
                            <dotlottie-player src="https://lottie.host/a3050f32-3032-4ab6-b2c6-033f098aa550/bZ3Hl79ot8.json" background="transparent" speed="1" style={{ width: '100px', height: '100px' }} loop autoplay></dotlottie-player>
                          </div>
                          <div className="flex-grow-1 ms-3">
                            <h5 className="persontexthead">**Congratulations {userDetails.Name}!**</h5>
                            <p className="card-text text-body persontextpara"> <b>{item.ChallengeName}</b> Challenge winner<br /> <span className="text-secondary">Announced by {item.CompanyName}.</span></p>
                            <h5 className="persontexthead">Great job! Click to view the details and celebrate your achievement.</h5>
                          </div>
                        </div>
                        <div className={item.MarkAsRead ? "" : "notification_dot"}>.</div>
                      </div>
                    </Card.Text>
                  )}
                </div>}
              </Card.Body>
            </Card>
          </div>


          <div>
            <Modal show={notificationShow} onHide={handleCloseNotification} size="lg" backdrop="static" keyboard={false} className="model-popup" dialogClassName="modal-90w modalwinner" centered>
              {/* {loading ? <GrokLoading /> : ""} */}
              <Modal.Header closeButton>
                <Modal.Title><b>Certificate of challenge completion</b> </Modal.Title>
                <div className='mx-5'>
                  <button className="downloadBtn" x={30} onClick={toPDF}>
                    <span><svg className='mb-1' stroke="currentColor" fill="none" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path d="M11 5C11 4.44772 11.4477 4 12 4C12.5523 4 13 4.44772 13 5V12.1578L16.2428 8.91501L17.657 10.3292L12.0001 15.9861L6.34326 10.3292L7.75748 8.91501L11 12.1575V5Z" fill="currentColor"></path><path d="M4 14H6V18H18V14H20V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V14Z" fill="currentColor"></path></svg>&nbsp;
                      Download
                    </span>
                  </button>
                </div>
              </Modal.Header>
              <div ref={targetRef}>
                <Modal.Body className="mx-2 my-3">
                  <div className="container pm-certificate-container">
                    <div className='border-widg1'>
                      <div className='border-widg2'>
                        <div className="pm-certificate-border col-md-12">
                          <div className="row pm-certificate-header">
                            <div className='certificate_logo'>
                              <img src={require("../../images/grok pvt ltd logo.png")} width={200} height={200} className="img-fluid" alt="logo" title="Profile" />
                            </div>
                            <div className='text-end px-3 my-2 d-flex'>
                              {/* <p className='mx-2'>Certificate No : </p> <h5 className='certificate_sty'></h5> */}
                            </div>
                            <div className="col-md-2"></div>
                            <div className="pm-certificate-title cursive col-md-12 text-center my-2">
                              <h1><b>Certificate of Challenge Completion</b></h1>
                            </div>
                          </div>

                          <div className="pm-certificate-body">

                            <div className="pm-certificate-block row">
                              <div className="col-md-12">
                                <div className="row">
                                  <div className="col-md-2"></div>
                                  <div className="pm-certificate-name underline margin-0 col-md-8 text-center">
                                    {Object.keys(certificateData).length && <span className="pm-name-text bold" >{certificateData.Student.Name}</span>}
                                  </div>
                                  <div className="col-md-2"></div>
                                </div>
                                <div className="row">
                                  <div className="col-md-2"></div>
                                  <div className="pm-certificate-name margin-0 col-md-8 text-center">
                                    <span className="pm-earned-text from_text padding-0 mt-1 block cursive text-bold">from</span>
                                    {Object.keys(certificateData).length && <span className="pm-name-text bold" >{certificateData.College.Name}</span>}
                                  </div>
                                  <div className="col-md-2"></div>
                                </div>
                              </div>

                              <div className="col-md-12">
                                <div className="row">
                                  <div className="col-md-2"></div>
                                  <div className="pm-earned col-md-8 text-center">
                                    <span className="pm-earned-text padding-0 block cursive">has Successfully Completed</span>
                                    {Object.keys(certificateData).length && <span className="pm-credits-text block bold sans" >at {certificateData.Challenge.Organization.Name}.</span>}
                                  </div>
                                  <div className="col-md-2"></div>
                                  <div className="col-md-12"></div>
                                </div>
                              </div>

                              <div className="col-md-12">
                                <div className="row">
                                  <div className="col-md-2"></div>
                                  <div className="pm-course-title col-md-8 text-center">
                                    <span className="pm-earned-text block cursive">while completing the challenge entitled</span>
                                  </div>
                                  <div className="col-md-2"></div>
                                </div>
                              </div>

                              <div className="col-md-12">
                                <div className="row">
                                  <div className="col-md-2"></div>
                                  <div className="pm-course-title underline col-md-8 text-center">
                                    {Object.keys(certificateData).length && <span className="pm-credits-text block bold sans" >{certificateData.Challenge.Title}</span>}
                                  </div>
                                  <div className="col-md-2"></div>
                                </div>
                              </div>
                            </div>


                            <div className="col-md-12 mt-2">
                              <div className="row">
                                <div className="col-md-4 pm-certified col-md-4 text-center">
                                  <span className="pm-credits-text block sans" >Royal Enfield Pvt Ltd, Chennai.</span>
                                  {Object.keys(certificateData).length && <span><img src={certificateData.Challenge.Organization.Logo} width={70} height={70} className="img-fluid my-1" alt="logo" title="Profile" /></span>}
                                  {/* <span className="pm-empty-space block underline"></span> */}
                                  <span className="bold block">Staff Development</span>
                                  <span className="bold block">Department.</span>
                                </div>
                                <div className="col-md-4"></div>
                                <div className="col-md-4 pm-certified col-md-4 text-center">
                                  <span className="pm-credits-text block sans">Authorized signatory</span>
                                  <span><img src={require("../../images/sign.png")} width={50} height={50} className="img-fluid my-1" alt="logo" title="Profile" /></span>
                                  {/* <span className="pm-empty-space block underline"></span> */}
                                  <span className="bold block">DIRECTOR</span>
                                  <span className="bold block">Grok Learning Pvt Ltd.</span>
                                </div>
                              </div>
                              <div className='row text-center text-primary'><span>www.grovator.com</span></div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal.Body>
              </div>
            </Modal>
          </div>
        </Container>
        <Footer />
      </div>
    </div>
  );
}

export default Notification;